export default __webpack_public_path__ + "static/media/Gloves of the Cackling Marionette.f3efe434.jpg";